import { render, staticRenderFns } from "./formViewer.vue?vue&type=template&id=83f3b35a&scoped=true"
import script from "./formViewer.vue?vue&type=script&lang=js"
export * from "./formViewer.vue?vue&type=script&lang=js"
import style0 from "./formViewer.vue?vue&type=style&index=0&id=83f3b35a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f3b35a",
  null
  
)

export default component.exports